import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let JobShadowingGallery2024 = () => {
    const verticalImageList = [
        "img01.jpeg",
        "img02.jpeg",
        "img04.jpeg",
        "img06.jpeg",
        "img07.jpeg",
        "img08.jpeg",
        "img11.jpeg",
        "img12.jpeg",
        "img15.jpeg",
        "img16.jpeg",
        "img18.jpeg",
        "img19.jpeg",
        "img22.jpeg",
        "img23.jpeg",
        "img25.jpeg",
        "img26.jpeg",
        "img28.jpeg",
        "img29.jpeg",
        "img30.jpeg",
        "img31.jpeg",
        "img32.jpeg",
        "img33.jpeg"
    ]

    const horizontalImageList = [
        "img03.jpeg",
        "img05.jpeg",
        "img09.jpeg",
        "img10.jpeg",
        "img13.jpeg",
        "img14.jpeg",
        "img17.jpeg",
        "img20.jpeg",
        "img21.jpeg",
        "img27.jpeg",
        "img34.jpeg",
        "img37.jpeg",
        "img38.jpeg",
        "img39.jpeg",
        "img40.jpeg" 
    ]

    return(
        <div className="content text-center">
            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-jobshadowing/" + path)} rounded />)}
            </div>
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-jobshadowing/" + path)} rounded />)}
            </div>

        </div>
    )
}

export default JobShadowingGallery2024;